var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Label } from '@/models/Label';
import { Component, Vue } from 'vue-property-decorator';
let SummaryLegendLabels = class SummaryLegendLabels extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.statusLabels = [];
        this.keyToDescription = {
            busy: this.$tc('legend.descriptions.busy'),
            highlighted: this.$tc('legend.descriptions.highlighted'),
            old: this.$tc('legend.descriptions.old'),
            inactive: this.$tc('legend.descriptions.inactive'),
            closed: this.$tc('legend.descriptions.closed'),
            finished: this.$tc('legend.descriptions.finished'),
            future: this.$tc('legend.descriptions.future'),
            dismissed: this.$tc('legend.descriptions.dismissed'),
        };
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.fetchLabels();
        this.isLoading = false;
    }
    fetchLabels() {
        new Label().all().then((labels) => {
            this.$store.dispatch('loadedLabels', labels);
            this.statusLabels = [];
            Object.keys(this.$t('idp.status')).forEach((status) => {
                const setting = this.$store.state.labels.find((label) => {
                    return label.key === status;
                });
                if (setting) {
                    setting.editing = false;
                    this.statusLabels.push(setting);
                }
                else {
                    this.statusLabels.push(new Label({ key: status, value: status, editing: false }));
                }
            });
        });
    }
};
SummaryLegendLabels = __decorate([
    Component({})
], SummaryLegendLabels);
export default SummaryLegendLabels;
